import { areMetadataInputsDisabled } from '../metadataInputsState';
import { useDocUploadStore } from '../store/store';

export function useMetadataInputsDisabled() {
  return useDocUploadStore((state) =>
    areMetadataInputsDisabled(state.fileState, state.metadataInputsLocked)
  );
}
